import React from 'react';
import Button from '../../../uikit/inputs/Button';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
export default function SubmitButton(_a) {
    var text = _a.text, withIcon = _a.withIcon, disabled = _a.disabled, onClick = _a.onClick;
    return (React.createElement(Button, { disabled: disabled, onClick: onClick, type: 'submit', endIcon: withIcon ? React.createElement(ArrowForwardIcon, null) : undefined, fullWidth: true }, text));
}
